import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Pagination from "react-js-pagination";
import { withRouter } from "react-router-dom";

import {
  isMobileDevice,
  validateEmail,
  validateNoSpaceInput,
} from "../../helpers/Utils";
import StyleConstants from "../../shared/constants/styleConstants/styles";
import { Loader, Text, ModalView } from "../common";
import {
  getFeeAccounts,
  createFeeAccount,
  updateFeeAccount,
} from "../../actions";

const IS_MOBILE = isMobileDevice();

class FeeAccounts extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      accountsPage: 1,
      perPage: 10,
      emailError: "",
      machineArrayError: "",
      displayFeeAccountForm: false,
      showEditModal: false,
      newFeeAccount: {
        name: "",
        address: "",
        gst_number: "",
        contact_number: "",
        contact_email: "",
        machine_ids: "",
        receipt_no_prefix: "",
        separate_series_for_cash_receipts: true,
        bank_name: "",
        account_number: "",
      },
      currentFeeAccount: {
        name: "",
        address: "",
        gst_number: "",
        contact_number: "",
        contact_email: "",
        machine_ids: "",
        receipt_no_prefix: "",
        separate_series_for_cash_receipts: "",
        bank_name: "",
        account_number: "",
      },
      hasAccess: true,
    };
    this.handleCloseEditModal = this.handleCloseEditModal.bind(this);
  }

  componentDidMount() {
    this.props.getFeeAccounts().then((data) => {
      this.setState({ hasAccess: data.success });
    });
  }

  handleCloseEditModal() {
    this.setState({
      showEditModal: false,
      displayFeeAccountForm: false,
      currentFeeAccount: {
        name: "",
        address: "",
        gst_number: "",
        contact_number: "",
        contact_email: "",
        machine_ids: "",
        receipt_no_prefix: "",
        separate_series_for_cash_receipts: "",
        bank_name: "",
        account_number: "",
      },
    });
  }

  handleFeeAccountFormSubmit(event, isEditForm) {
    event.preventDefault();
    const { newFeeAccount, currentFeeAccount } = this.state;
    const feeDetails = isEditForm ? currentFeeAccount : newFeeAccount;
    if (isEditForm) {
      this.props.updateFeeAccount(feeDetails).then((response) => {
        if (response.success) {
          this.handleCloseEditModal();
          window.location.reload();
        }
      });
    } else {
      this.props.createFeeAccount(feeDetails).then((response) => {
        if (response.success) {
          this.setState({
            newFeeAccount: {
              name: "",
              address: "",
              gst_number: "",
              contact_number: "",
              contact_email: "",
              machine_ids: "",
              receipt_no_prefix: "",
              bank_name: "",
              account_number: "",
            },
            displayFeeAccountForm: false,
            showEditModal: false,
          });
          window.location.reload();
        }
      });
    }
  }

  handleFeeAccountFormInputChange(event, type, isEditForm) {
    if (isEditForm) {
      this.setState({
        currentFeeAccount: {
          ...this.state.currentFeeAccount,
          [type]: event.target.value,
        },
      });
    } else {
      this.setState({
        newFeeAccount: {
          ...this.state.newFeeAccount,
          [type]: event.target.value,
        },
      });
    }
  }

  renderSubHeading(text) {
    return (
      <Text
        color={StyleConstants.textColor.primary}
        fontSize={StyleConstants.textSize.secondaryHeader}
        fontWeight={StyleConstants.textWeight.bold}
        style={{ textDecoration: "underline" }}
        text={text}
      />
    );
  }

  renderModal() {
    const { showEditModal } = this.state;
    return (
      <ModalView
        key={showEditModal}
        header={"Update Account Details"}
        isModalVisible={showEditModal}
        handleCloseModal={this.handleCloseEditModal}
        width={600}
      >
        {this.renderFeeAccountForm(true)}
      </ModalView>
    );
  }

  renderFeeAccountForm(isEditForm = false) {
    const { newFeeAccount, currentFeeAccount, emailError, machineArrayError } =
      this.state;
    const feeDetails = isEditForm ? currentFeeAccount : newFeeAccount;
    const {
      name,
      address,
      gst_number: gstNumber,
      contact_email: contactEmail,
      contact_number: contactNumber,
      machine_ids: machineIds,
      receipt_no_prefix: receipt_no_prefix,
      separate_series_for_cash_receipts: separateSeriesForCashReceipts,
      bank_name: bankName,
      account_number: accountNumber,
    } = feeDetails;
    const labelStyle = {
      display: "flex",
      justifyContent: "flex-start",
      width: 150,
    };
    const containerStyle = {
      display: "flex",
      margin: "10px 0px",
      maxWidth: 700,
      alignItems: "center",
    };

    return (
      <form
        onSubmit={(event) => this.handleFeeAccountFormSubmit(event, isEditForm)}
        onReset={() =>
          this.setState({ displayFeeAccountForm: false, showEditModal: false })
        }
      >
        <fieldset
          style={{ width: isEditForm ? !IS_MOBILE && 570 : !IS_MOBILE && 750 }}
        >
          <legend>Fee Account Details:</legend>
          <div style={containerStyle}>
            <label style={labelStyle} htmlFor="fee_name">
              Name:
            </label>
            <input
              value={name}
              onChange={(event) =>
                this.handleFeeAccountFormInputChange(event, "name", isEditForm)
              }
              style={{
                marginLeft: 10,
                width: isEditForm ? !IS_MOBILE && 400 : !IS_MOBILE && 450,
              }}
              type="text"
              name="fee_name"
              id="fee_name"
              maxLength="100"
              required
              aria-required="true"
            />
          </div>
          <div style={containerStyle}>
            <label style={labelStyle} htmlFor="address">
              Address:
            </label>
            <input
              value={address}
              onChange={(event) =>
                this.handleFeeAccountFormInputChange(
                  event,
                  "address",
                  isEditForm
                )
              }
              style={{
                marginLeft: 10,
                width: isEditForm ? !IS_MOBILE && 400 : !IS_MOBILE && 450,
              }}
              type="text"
              name="address"
              id="address"
              maxLength="100"
              aria-required="true"
            />
          </div>
          <div style={containerStyle}>
            <label style={labelStyle} htmlFor="bank_name">
              Bank Name:
            </label>
            <input
              value={bankName}
              onChange={(event) =>
                this.handleFeeAccountFormInputChange(
                  event,
                  "bank_name",
                  isEditForm
                )
              }
              style={{
                marginLeft: 10,
                width: isEditForm ? !IS_MOBILE && 400 : !IS_MOBILE && 450,
              }}
              type="text"
              name="bank_name"
              id="bank_name"
              maxLength="100"
              required
              aria-required="true"
            />
          </div>
          <div style={containerStyle}>
            <label style={labelStyle} htmlFor="account_number">
              Account Number:
            </label>
            <input
              value={accountNumber}
              onChange={(event) =>
                this.handleFeeAccountFormInputChange(
                  event,
                  "account_number",
                  isEditForm
                )
              }
              style={{
                marginLeft: 10,
                width: isEditForm ? !IS_MOBILE && 400 : !IS_MOBILE && 450,
              }}
              type="text"
              name="account_number"
              id="account_number"
              maxLength="100"
              required
              aria-required="true"
            />
          </div>
          <div style={containerStyle}>
            <label style={labelStyle} htmlFor="gst_number">
              GST Number:
            </label>
            <input
              value={gstNumber}
              onChange={(event) => {
                if (event.target.value.length > 15) {
                  return;
                }
                this.handleFeeAccountFormInputChange(
                  event,
                  "gst_number",
                  isEditForm
                );
              }}
              style={{
                marginLeft: 10,
                width: isEditForm ? !IS_MOBILE && 400 : !IS_MOBILE && 450,
              }}
              type="text"
              name="gst_number"
              id="gst_number"
              maxLength="100"
              aria-required="true"
            />
          </div>
          <div style={containerStyle}>
            <label style={labelStyle} htmlFor="contact_number">
              Contact Number:
            </label>
            <input
              value={contactNumber}
              type="text"
              onChange={(event) => {
                this.handleFeeAccountFormInputChange(
                  event,
                  "contact_number",
                  isEditForm
                );
              }}
              style={{
                marginLeft: 10,
                width: isEditForm ? !IS_MOBILE && 400 : !IS_MOBILE && 450,
              }}
              name="contact_number"
              id="contact_number"
              aria-required="true"
            />
          </div>
          <div style={containerStyle}>
            <label style={labelStyle} htmlFor="contact_email">
              Contact Email:
            </label>
            <input
              value={contactEmail}
              onChange={(event) => {
                this.handleFeeAccountFormInputChange(
                  event,
                  "contact_email",
                  isEditForm
                );
                const validEmail = validateEmail(event.target.value);
                if (!validEmail) {
                  this.setState({ emailError: "Please enter a valid E-mail" });
                  return;
                }
                this.setState({ emailError: "" });
              }}
              style={{
                marginLeft: 10,
                width: isEditForm ? !IS_MOBILE && 400 : !IS_MOBILE && 450,
              }}
              type="text"
              name="contact_email"
              id="contact_email"
              maxLength="100"
              aria-required="true"
            />
          </div>
          <div style={containerStyle}>
            <label style={labelStyle} htmlFor="machine_ids">
              POS machine IDs:
            </label>
            <input
              value={machineIds}
              onChange={(event) => {
                this.handleFeeAccountFormInputChange(
                  event,
                  "machine_ids",
                  isEditForm
                );
                const validArray = validateNoSpaceInput(event.target.value);
                if (!validArray) {
                  this.setState({
                    machineArrayError:
                      "Please enter comma separated values only. Eg: 1,2,a3,b-6...",
                  });
                  return;
                }
                this.setState({ machineArrayError: "" });
              }}
              style={{
                marginLeft: 10,
                width: isEditForm ? !IS_MOBILE && 400 : !IS_MOBILE && 450,
              }}
              type="text"
              name="machine_ids"
              id="machine_ids"
              maxLength="100"
              aria-required="true"
            />
          </div>
          <div style={containerStyle}>
            <label style={labelStyle} htmlFor="receipt_no_prefix">
              Prefix:
            </label>
            <input
              value={receipt_no_prefix}
              onChange={(event) => {
                this.handleFeeAccountFormInputChange(
                  event,
                  "receipt_no_prefix",
                  isEditForm
                );
              }}
              style={{
                marginLeft: 10,
                width: isEditForm ? !IS_MOBILE && 400 : !IS_MOBILE && 450,
              }}
              type="text"
              name="receipt_no_prefix"
              id="receipt_no_prefix"
              maxLength="100"
              aria-required="true"
            />
          </div>
          <div style={containerStyle}>
            <div style={labelStyle}>Separate series for cash receipts:</div>
            <label className="switch">
              <input
                type="checkbox"
                checked={separateSeriesForCashReceipts}
                onChange={() => {
                  if (isEditForm) {
                    this.setState({
                      currentFeeAccount: {
                        ...this.state.currentFeeAccount,
                        separate_series_for_cash_receipts:
                          !separateSeriesForCashReceipts,
                      },
                    });
                  } else {
                    this.setState({
                      newFeeAccount: {
                        ...this.state.newFeeAccount,
                        separate_series_for_cash_receipts:
                          !separateSeriesForCashReceipts,
                      },
                    });
                  }
                }}
              />
              <span className="slider round" />
            </label>
          </div>

          {!!emailError && (
            <div style={{ marginTop: 10, color: "red" }}>{emailError}</div>
          )}
          {!!machineArrayError && (
            <div style={{ marginTop: 10, color: "red" }}>
              {machineArrayError}
            </div>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: IS_MOBILE ? "center" : "flex-start",
            }}
          >
            <button
              type="reset"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: 180,
                height: 35,
                borderColor: StyleConstants.color.darkBlue,
                borderWidth: 1,
                borderRadius: 4,
                lineHeight: 0,
                fontSize: 14,
                cursor: "pointer",
                marginTop: 10,
                marginRight: 15,
                fontFamily: "'Poppins', sans-serif",
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: 180,
                height: 35,
                backgroundColor: StyleConstants.color.darkBlue,
                borderColor: StyleConstants.color.darkBlue,
                color: "#FFFFFF",
                borderRadius: 4,
                lineHeight: 0,
                fontSize: 14,
                cursor: "pointer",
                marginTop: 10,
                fontFamily: "'Poppins', sans-serif",
              }}
            >
              Submit
            </button>
          </div>
        </fieldset>
      </form>
    );
  }

  renderFeeAccountCreationForm() {
    const { displayFeeAccountForm, showEditModal } = this.state;
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "30px 50px",
        }}
      >
        {(!displayFeeAccountForm || showEditModal) && (
          <div
            className="Button Primary-Button"
            style={{ width: 150 }}
            onClick={() => this.setState({ displayFeeAccountForm: true })}
          >
            Create Fee Account
          </div>
        )}
        {displayFeeAccountForm && !showEditModal && this.renderFeeAccountForm()}
      </div>
    );
  }

  renderFeeAccounts() {
    const { feeAccounts, isFinance } = this.props;
    const { accountsPage, perPage } = this.state;
    const headings = isFinance
      ? [
          "S.No",
          "Name",
          "GST Number",
          "Address",
          "Contact Email",
          "Contact Phone",
          "Machine IDs",
        ]
      : [
          "S.No",
          "Name",
          "GST Number",
          "Address",
          "Contact Email",
          "Contact Phone",
          "Machine IDs",
          "",
        ];

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          margin: "0px 50px",
          overflowX: "auto",
        }}
      >
        <table
          className="table table-bordered"
          style={{
            boxShadow: "1px 2px 6px #8B9DAF33",
            margin: "10px 0",
          }}
        >
          <thead>
            <tr
              className="table-header"
              style={{
                fontSize: "18px",
                fontWeight: "700",
                height: 55,
                paddingLeft: 20,
              }}
            >
              {headings.map((heading, index) => {
                let width = "10%";

                if (index === 0) {
                  width = "5%";
                } else if (index === 1) {
                  width = "20%";
                }
                return (
                  <th
                    key={index + 1}
                    style={{
                      width,
                      textAlign: "center",
                    }}
                  >
                    {heading.toLocaleUpperCase()}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {feeAccounts
              .slice((accountsPage - 1) * perPage, accountsPage * perPage)
              .map((account, index) => {
                const rowData = [
                  (accountsPage - 1) * perPage + index + 1,
                  account.name,
                  account.gst_number,
                  account.address,
                  account.contact_email,
                  account.contact_number,
                  account.machine_ids.join(","),
                ];
                return (
                  <tr
                    key={rowData[0]}
                    style={{
                      fontSize: StyleConstants.textSize.subHeader,
                      color: "#343737",
                      fontWeight: "400",
                    }}
                  >
                    {rowData.map((key, columnIndex) => {
                      return (
                        <td
                          key={`${rowData[0]} - ${columnIndex}`}
                          role="presentation"
                          style={{
                            textAlign:
                              columnIndex === rowData.length - 1
                                ? "right"
                                : "left",
                            padding:
                              columnIndex === rowData.length - 1
                                ? "12px 24px"
                                : "12px",
                          }}
                        >
                          {key}
                        </td>
                      );
                    })}
                    {!isFinance && (
                      <td style={{ display: "flex", justifyContent: "center" }}>
                        <div
                          className="Button Secondary-Button"
                          style={{ width: 70, marginRight: 15 }}
                          onClick={() =>
                            this.setState({
                              showEditModal: true,
                              displayFeeAccountForm: true,
                              currentFeeAccount: account,
                            })
                          }
                        >
                          Edit
                        </div>
                      </td>
                    )}
                  </tr>
                );
              })}
          </tbody>
        </table>
        <Pagination
          activePage={accountsPage}
          itemsCountPerPage={perPage}
          totalItemsCount={feeAccounts.length}
          pageRangeDisplayed={IS_MOBILE ? 3 : 10}
          onChange={(pageNumber) => this.setState({ accountsPage: pageNumber })}
        />
      </div>
    );
  }

  noPermission() {
    return (
      <div
        style={{
          paddingTop: 200,
          paddingLeft: 300,
          width: "100%",
          backgroundColor: "#F5F8FA",
          fontSize: "20px",
        }}
      >
        <span style={{ borderStyle: "solid", padding: "10px" }}>
          You dont have permission to access to this page{" "}
        </span>
      </div>
    );
  }

  render() {
    const { showEditModal, hasAccess } = this.state;
    const { isFinance } = this.props;
    if (this.props.isLoading) {
      return <Loader />;
    }
    return (
      <div>
        {hasAccess ? (
          <div>
            {!isFinance && this.renderFeeAccountCreationForm()}
            {this.renderFeeAccounts()}
            {showEditModal && this.renderModal()}
          </div>
        ) : (
          this.noPermission()
        )}
      </div>
    );
  }
}

FeeAccounts.propTypes = {
  isLoading: PropTypes.bool,
  feeAccounts: PropTypes.array,
};

FeeAccounts.defaultProps = {
  feeAccounts: [],
};

const mapStateToProps = ({ report, home }) => ({
  isLoading: report.isLoading,
  feeAccounts: report.feeAccounts,
  isFinance: home.isFinance,
});

export default withRouter(
  connect(mapStateToProps, {
    getFeeAccounts,
    createFeeAccount,
    updateFeeAccount,
  })(FeeAccounts)
);
